var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseDs = function SvgCloseDs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1778_22514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6491 12.0156L20.6579 5.00652C21.114 4.55061 21.114 3.81347 20.6579 3.35756C20.202 2.90165 19.4649 2.90165 19.009 3.35756L11.9999 10.3666L4.99106 3.35756C4.53493 2.90165 3.798 2.90165 3.34209 3.35756C2.88597 3.81347 2.88597 4.55061 3.34209 5.00652L10.3509 12.0156L3.34209 19.0246C2.88597 19.4805 2.88597 20.2177 3.34209 20.6736C3.5693 20.901 3.86804 21.0153 4.16657 21.0153C4.4651 21.0153 4.76364 20.901 4.99106 20.6736L11.9999 13.6645L19.009 20.6736C19.2364 20.901 19.5349 21.0153 19.8334 21.0153C20.132 21.0153 20.4305 20.901 20.6579 20.6736C21.114 20.2177 21.114 19.4805 20.6579 19.0246L13.6491 12.0156Z",
    fill: "#2B2E54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1778_22514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseDs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Close-ds.8f1e598372324932c1a40d69fbf87fb6.svg";